<template>
  <div
    :id="id"
    class="c-modal modal"
    tabindex="0"
    style="
      z-index: 1003;
      display: none;
      opacity: 0;
      top: 4%;
      transform: scaleX(0.8) scaleY(0.8);
    "
  >
    <div class="c-modal--directions-title"><h2>Tipo comprobante</h2></div>
    <div class="c-section--content-date-options">
      <div class="c-collection collection d-flex m-0 collection-option">
        <div
          data-img="svg-dni"
          class="collection-item"
          :class="{
            active: checkedTypeVoucher === 'Boleta',
          }"
        >
          <label class="c-radio-buttons c-rb-item-type-doc"
            ><input
              name="option-type-doc"
              type="radio"
              value="Boleta"
              v-model="checkedTypeVoucher"
            /><span>Boleta</span></label
          >
        </div>
        <div
          data-img="svg-docImmigration"
          class="collection-item"
          :class="{
            active: checkedTypeVoucher === 'Factura',
          }"
        >
          <label class="c-radio-buttons c-rb-item-type-doc"
            ><input
              name="option-type-doc"
              type="radio"
              value="Factura"
              v-model="checkedTypeVoucher"
            /><span>Factura</span></label
          >
        </div>
      </div>
    </div>
    <div class="c-modal--directions-body">
      <div class="c-input input-field">
        <input
          type="text"
          v-show="checkedTypeVoucher === 'Boleta'"
          v-model="name"
        />
        <input
          type="text"
          v-show="checkedTypeVoucher === 'Factura'"
          v-model="razonSocial"
        />
        <label for="" v-show="checkedTypeVoucher === 'Boleta'"
          >Nombre y Apellido</label
        >
        <label for="" v-show="checkedTypeVoucher === 'Factura'"
          >Razon Social</label
        >
      </div>
      <div class="c-input input-field">
        <input
          type="text"
          v-show="checkedTypeVoucher === 'Boleta'"
          v-model="documentNumber"
          @keypress="onlyNumbers"
        />
        <input
          type="text"
          v-show="checkedTypeVoucher === 'Factura'"
          v-model="ruc"
          @keypress="onlyNumbers"
        />
        <label for="" v-show="checkedTypeVoucher === 'Boleta'">DNI</label>
        <label for="" v-show="checkedTypeVoucher === 'Factura'">RUC</label>
      </div>
      <div class="c-input input-field">
        <input type="text" v-model="phone" @keypress="onlyNumbers" />
        <label for="">Celular</label>
      </div>
      <div class="c-input input-field">
        <input type="text" v-model="email" />
        <label for="">Correo Electrónico</label>
      </div>

      <!-- <div
        class="c-section--content-check justify-content-around align-items-center"
        style="margin: 10px 0px"
      >
        <p class="font-weight-light">Guardarlo como favorito</p>
        <div class="switch">
          <label
            ><input type="checkbox" v-model="favorite" />
            <span class="lever"></span>
          </label>
        </div>
      </div> -->
    </div>
    <div class="c-modal__footer-buttons c-nav m-1">
      <button
        class="c-button c-button--primary c-button--width-fuid c-button--mobile-small waves-effect"
        @click="sendVoucherData"
      >
        Guardar
      </button>
      <button
        class="c-button c-button--width-fuid c-button--flat c-button--mobile-small waves-effect modal-close"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalTypeVoucher",
  props: {
    id: String,
  },
  data() {
    return {
      checkedTypeVoucher: "Boleta",
      ruc: "",
      razonSocial: "",
      name: "",
      documentNumber: "",
      phone: "",
      email: "",
      favorite: false,
    };
  },
  watch: {
    checkedTypeVoucher() {
      // this.name = "";
      // this.documentNumber = "";
    },
  },
  computed: {
    user() {
      return this.$store.getters.USER;
    },
  },
  async mounted() {
    this.checkedTypeVoucher = this.user.ruc ? "Factura" : "Boleta";
    this.ruc = this.user.ruc;
    this.razonSocial = this.user.razonSocial;
    this.name = this.user.fullName;
    this.documentNumber = this.user.dni;
    this.phone = this.user.celular;
    this.email = this.user.email;
  },
  methods: {
    validData() {
      if (
        !this.name ||
        (this.checkedTypeVoucher === "Boleta" && !this.documentNumber) ||
        (this.checkedTypeVoucher === "Factura" && !this.ruc) ||
        (this.checkedTypeVoucher === "Boleta" && !this.name) ||
        (this.checkedTypeVoucher === "Factura" && !this.razonSocial) ||
        !this.phone ||
        !this.email
      ) {
        this.showError("Por favor, rellena la información correctamente.");
        return false;
      }

      if (this.phone.length !== 9) {
        this.showError("El campo número de telefono debe poseer 9 digitos.");
        return false;
      }

      if (!this.validateEmail(this.email)) {
        this.showError("Por favor, ingrese un email válido.");
        return false;
      }

      if (
        this.checkedTypeVoucher === "Boleta" &&
        this.documentNumber.length !== 8
      ) {
        this.showError("DNI debe tener 8 caracteres.");
        return false;
      }

      if (
        this.checkedTypeVoucher === "Factura" &&
        this.ruc.length !== 11
      ) {
        this.showError("RUC debe tener 11 caracteres.");
        return false;
      }

      return true;
    },
    sendVoucherData() {
      const isValid = this.validData();

      if (isValid === true) {
        const voucherData = {
          typeVoucher: this.checkedTypeVoucher,
          name: this.checkedTypeVoucher === "Boleta"? this.name : this.razonSocial,
          documentNumber:this.checkedTypeVoucher === "Boleta"? this.documentNumber : this.ruc ,
          phone: this.phone,
          email: this.email,
        };
        this.$emit("getVoucherData", voucherData);
        this.closeModal(this.id);
      }
    },
  },
};
</script>

<style></style>
